import React from 'react';

import LogoutComp from '../components/Auth/Logout';

interface ILogout {
  messageKey: 'M1' | 'M2' | 'M3' | 'M4' | 'M5' | 'M6';
}

const Logout: React.FC<ILogout> = ({ messageKey }) => {
  return <LogoutComp messageKey={messageKey} />;
};

export default Logout;
